<div class="relative w-full group">
  @if (label()) {
    <p
      class="absolute text-sm -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-text">
      {{ label() }}
    </p>
  }
  <div
    class="px-3 py-[1.1rem] flex flex-col items-center w-full border border-neutral-200 rounded-lg sm:text-sm focus:ring-0 placeholder:text-neutral-700 justify-between">
    <div class="flex items-center justify-between w-full">
      <ui-button
        [fitContent]="true"
        (click)="onButtonClick()"
        class="shrink-0"
        [disabled]="isDisabled">
        Choose File
        <input
          type="file"
          [id]="fileInputId()"
          [disabled]="isDisabled"
          (change)="onFileChange($event)"
          (blur)="onBlur()"
          [accept]="accept()"
          #fileInput
          title=" "
          class="opacity-0 w-0 h-0" />
      </ui-button>
      <div
        class="flex items-center w-full"
        [class]="hasFiles ? 'justify-between' : 'justify-end'">
        @if (hasFiles) {
          <div class="ml-3 border border-neutral-200 rounded-xl px-3 py-1">
            <div class="flex items-center">
              <span class="text-sm text-text">{{ fileDisplayName }}</span>
              <span
                tabindex="0"
                class="cursor-pointer ml-4 text-xs text-neutral-700 mt-1"
                (click)="clearFiles()">
                <fa-icon
                  size="lg"
                  class="text-neutral-700 opacity-50"
                  [icon]="faXmark" />
              </span>
            </div>
          </div>
        } @else {
          <span class="text-sm text-neutral-500"
            >{{ fileList()?.length }} files</span
          >
        }
        <span
          tabindex="0"
          class="cursor-pointer ml-4 text-xs text-neutral-700 px-2"
          (click)="onListOpenClick()">
          <fa-icon
            size="lg"
            class="text-neutral-700 opacity-50"
            [icon]="faChevronDown"
            [rotate]="isListOpen() ? '180deg' : '0deg'" />
        </span>
      </div>
    </div>
    @if (isListOpen()) {
      <div class="w-full mt-8 px-2">
        @for (file of fileList(); track file.id) {
          <div
            class="flex items-center w-full justify-between odd:bg-neutral-100 rounded-lg p-2">
            <span class="text-sm text-text">{{ file.filename }}</span>
            <div class="shrink-0">
              <span
                tabindex="0"
                [class.cursor-not-allowed]="isDisabled || isDeleteDisable()"
                [class.opacity-50]="isDisabled || isDeleteDisable()"
                [class.cursor-pointer]="!isDisabled && !isDeleteDisable()"
                class="ml-4 text-xs text-neutral-700 mt-1 px-2 py-1 bg-neutral-500 rounded-lg"
                (click)="
                  !isDisabled && !isDeleteDisable()
                    ? deleteFile.emit(file)
                    : null
                ">
                <fa-icon
                  size="lg"
                  class="text-white"
                  [icon]="faCircleXmark"
                  matTooltip="Remove document"
                  matTooltipPosition="above"
                  matTooltipClass="file-tooltip" />
              </span>
              <span
                tabindex="0"
                class="cursor-pointer ml-2 text-xs text-neutral-700 mt-1 px-2 py-1 bg-primary-700 rounded-lg"
                (click)="viewFile.emit(file)">
                <fa-icon
                  size="lg"
                  class="text-white"
                  [icon]="faEye"
                  matTooltip="View document"
                  matTooltipPosition="above"
                  matTooltipClass="file-tooltip" />
              </span>
            </div>
          </div>
        } @empty {
          <div
            class="flex items-center w-full justify-between odd:bg-neutral-100 rounded-lg p-2">
            <span class="text-sm text-text"
              >No files uploaded for this section</span
            >
          </div>
        }
      </div>
    }
  </div>
</div>
